<template>
  <div class="row m-0 py-2">
    <div id="top1" ref="top1" class="top1" style="direction: ltr; overflow-y: auto;">
      <div class="text-start w-50 d-md-inline-block d-none">
        <button class="bt-login mt-1 fs-6 mx-2" @click="disconnect()">Disconnect</button>
        <button v-if="credits == 4" class="bt-login mt-1 fs-6 ml-1 mx-2" @click="ufor()">Forex Users</button>
        <button v-if="credits == 4" class="bt-login mt-1 fs-6 ml-1 mx-2" @click="ucrypto()">Crypto Users</button>
      </div>
      <div class="text-end w-50 d-md-inline-block d-none">
        <div>
          <input type="text" placeholder="Signal Search ..." class="py-1 w-50" v-model="search">
          <button class="bt-login mt-1 ml-1 mx-2 px-3 py-2" @click="searchItem()">Search</button>
        </div>
      </div>
      <div class="text-start d-md-none d-block">
        <button class="bt-login mt-1 fs-6 mx-1 px-3" @click="disconnect()">Disconnect</button>
        <button v-if="credits == 4" class="bt-login mt-1 fs-6 ml-1 mx-1 px-3" @click="ufor()">Forex Users</button>
        <button v-if="credits == 4" class="bt-login mt-1 fs-6 ml-1 mx-1 px-3" @click="ucrypto()">Crypto Users</button>
      </div>
      <div class="text-end d-md-none d-block mt-3">
        <div>
          <input type="text" placeholder="Signal Search ..." class="py-1 w-50" v-model="search">
          <button class="bt-login mt-1 ml-1 mx-2 px-3 py-2" @click="searchItem()">Search</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-0 p-0" style="height: 100vh;">
    <div v-if="credits == 1" id="chat1" ref="chat1" class="chat1" style="direction: ltr; background-color: #adadad; overflow-y: auto;max-height: 100vh;">
      <!-- محتوا -->
    </div>
    <div v-else-if="credits == 2" id="chat2" ref="chat2" class="chat2" style="direction: ltr; background-color: #d9d9d9; overflow-y: auto;max-height: 100vh;">
      <!-- محتوا -->
    </div>
    
    <div v-else-if="credits == 3 || credits ==4" class="row p-0 m-0">
      <ul class="nav nav-tabs d-md-none d-block mt-2" id="myTab" role="tablist" style="height: 50px;">
        <li class="nav-item d-inline-block" role="presentation">
          <button class="nav-link" id="home-tab" @click="setButton('home')" type="button" role="tab" aria-controls="home" aria-selected="true">Crypto</button>
        </li>
        <li class="nav-item d-inline-block" role="presentation">
          <button class="nav-link" id="profile-tab" @click="setButton('profile')" type="button" role="tab" aria-controls="profile" aria-selected="false">Forex</button>
        </li>
      </ul>
      <div id="chat1" ref="chat1" class="chat1 col-md-6" style="direction: ltr; background-color: #adadad; overflow-y: auto; border-left: solid 1px #555555;height: 100vh;">
        <!-- محتوا -->
      </div>
      <div id="chat2" ref="chat2" class="chat2 col-md-6" style="direction: ltr; background-color: #d9d9d9; overflow-y: auto;height: 100vh;">
        <!-- محتوا -->
      </div>
    </div>
    <div v-else-if="credits == 5" id="chat3" ref="chat3" class="chat3" style="direction: ltr; background-color: #adadad; overflow-y: auto;max-height: 100vh;">
      <!-- محتوا -->
    </div>
    <div v-else-if="credits == 6" id="chat4" ref="chat4" class="chat4" style="direction: ltr; background-color: #d9d9d9; overflow-y: auto;max-height: 100vh;">
      <!-- محتوا -->
    </div>
    

    <div v-else-if="credits == 7" class="row p-0 m-0">
      <ul class="nav nav-tabs d-md-none d-block mt-2" id="myTab" role="tablist" style="height: 50px;">
        <li class="nav-item d-inline-block" role="presentation">
          <button class="nav-link" id="home-tab" @click="setButton('home')" type="button" role="tab" aria-controls="home" aria-selected="true">Crypto</button>
        </li>
        <li class="nav-item d-inline-block" role="presentation">
          <button class="nav-link" id="profile-tab" @click="setButton('profile')" type="button" role="tab" aria-controls="profile" aria-selected="false">Forex</button>
        </li>
      </ul>
      <div id="chat3" ref="chat3" class="chat3 col-md-6" style="direction: ltr; background-color: #adadad; overflow-y: auto; border-left: solid 1px #555555;height: 100vh;">
        <!-- محتوا -->
      </div>
      <div id="chat4" ref="chat4" class="chat4 col-md-6" style="direction: ltr; background-color: #d9d9d9; overflow-y: auto;height: 100vh;">
        <!-- محتوا -->
      </div>
    </div>
  </div>
  <!-- Large modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="direction: ltr;">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5 text-start" id="exampleModalLabel">Signals</h1>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="height: 87vh;overflow-y: scroll;">
        <div v-for="(item,i) in signals" :key="i">
          {{ item.hgt }} | {{ item.date1 }}
          <br>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
  <button id="modalButton" type="button" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal"></button>
  <div class="d-md-none d-block">
    <onlineSignalsSmallSize v-if="credits" :credits="credits"/>
  </div>
</template>

<script>
import SignalsOnlineApiService from '../ApiServices/HeyvaOnlineApiService'
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios';
import Swal from 'sweetalert2';

export default defineComponent({
  components: {},
  name: 'App',
  setup() {
    const router = useRouter()
    const credits = ref()
    const phones = ref()
    const chat1 = ref(null)
    const chat2 = ref(null)
    const chat3 = ref(null)
    const chat4 = ref(null)
    const search = ref()
    const signals = ref()

    function setButton(item){
      if (item=='home') {
        document.getElementById('chat1').style.display = 'block'
        document.getElementById('chat2').style.display = 'none'
        document.getElementById('chat3').style.display = 'block'
        document.getElementById('chat4').style.display = 'none'
      }
      if (item=='profile') {
        document.getElementById('chat2').style.display = 'block'
        document.getElementById('chat1').style.display = 'none'
        document.getElementById('chat4').style.display = 'block'
        document.getElementById('chat3').style.display = 'none'
      }
    }

    onMounted(() => {
      console.log('onMounted called');
      localStorage.setItem('routeName', 'heyva general trading system')
      localStorage.setItem('routePath', 'heyva general trading system')
      window.dispatchEvent(new CustomEvent('route-changed', {
        detail: {
          name: localStorage.getItem('routeName'),
          path: localStorage.getItem('routePath')
        }
      }))

      if (localStorage.getItem('credits')) {
        credits.value = Number(localStorage.getItem('credits'))
        phones.value = Number(localStorage.getItem('phones'))
        if (credits.value == 1) {
          console.log('Calling setupSocketConnection for Room1');
          SignalsOnlineApiService.setupSocketConnection('joinRoom1', 'HeyvaRoom1')
        } else if (credits.value == 2) {
          console.log('Calling setupSocketConnection for Room2');
          SignalsOnlineApiService.setupSocketConnection('joinRoom2', 'HeyvaRoom2')
        } else if (credits.value == 3) {
          console.log('Calling setupSocketConnection for Room3');
          SignalsOnlineApiService.setupSocketConnection('joinRoom1', 'HeyvaRoom1')
          SignalsOnlineApiService.setupSocketConnection('joinRoom2', 'HeyvaRoom2')
        }else if (credits.value == 4) {
          console.log('Calling setupSocketConnection for Room4');
          SignalsOnlineApiService.setupSocketConnection('joinRoom1', 'HeyvaRoom1')
          SignalsOnlineApiService.setupSocketConnection('joinRoom2', 'HeyvaRoom2')
        }else if (credits.value == 5) {
          console.log('Calling setupSocketConnection for Room5');
          SignalsOnlineApiService.setupSocketConnection('joinRoom3', 'HeyvaRoom3')
        }else if (credits.value == 6) {
          console.log('Calling setupSocketConnection for Room6');
          SignalsOnlineApiService.setupSocketConnection('joinRoom4', 'HeyvaRoom4')
        }else if (credits.value == 7) {
          console.log('Calling setupSocketConnection for Room7');
          SignalsOnlineApiService.setupSocketConnection('joinRoom3', 'HeyvaRoom3')
          SignalsOnlineApiService.setupSocketConnection('joinRoom4', 'HeyvaRoom4')
        }
        
        // setInterval(() => {
        //   //SignalsOnlineApiService.disconnect()
        //   window.location.reload()
        // }, 10 * 60 * 1000)
      } else {
        router.push({ name: 'login' })
      }

      
    })

    function disconnect(){
      SignalsOnlineApiService.disconnect()
    }

    function ufor(){
      axios.put('https://signal.heyvaai.com/user/uforex',{'email':localStorage.getItem('users')}).then((res)=>{
          if (res.status==200) {
            var vc = ""
            for (let i = 0; i < res.data.users.length; i++) 
            {
              vc = vc + res.data.users[i].name +"<br/>";
            }
              Swal.fire({
                html: vc,
                icon: "info"
              });
          }
      }).catch((error)=>{                    
          Swal.fire({
                text: error.response.data.mess,
                icon: "error"
              });
      })
            
    }

    function ucrypto(){
      axios.put('https://signal.heyvaai.com/user/ucrypto',{'email':localStorage.getItem('users')}).then((res)=>{
          console.log(res)
          if (res.status==200) {
            var vc = ""
            for (let i = 0; i < res.data.users.length; i++) 
            {
              vc = vc + res.data.users[i].name +"<br/>";
            }
              Swal.fire({
                html: vc,
                icon: "info"
              });
          }
      }).catch((error)=>{                    
          Swal.fire({
                text: error.response.data.mess,
                icon: "error"
              });
      })
        
    }

    function searchItem() {
      if (search.value) {
        axios.put(`https://signal.heyvaai.com/user/signalsearch/${search.value}`,{'email':localStorage.getItem('users')}).then((res)=>{
          signals.value = res.data.signals[0]
          document.getElementById('modalButton').click();
        })
      }
    }

    function uforex(){
      SignalsOnlineApiService.disconnect()
    }
    
    return {
      router,
      credits,
      chat1,
      chat2,
      chat3,
      chat4,
      setButton,
      disconnect,
      ufor,
      ucrypto,
      search,
      searchItem,
      signals,
    }
  }
})

</script>

<style scoped lang="scss">
@import url("/src/assets/scss/chatBot.scss");

.container {
  height: 100vh !important;
  width: 100vw !important;
  position: relative;
  right: 0;
  bottom: 0;
  border-radius: 0px;
}

.header {
  margin: 0px 20px;
  padding-top: 0px;
}

.input {
  width: 90%;
  @media (max-width: 570px) {
    width: 85%;
  }
}

.send-icon {
  width: 5%;
}

.chat {
  padding-top: 30px;
  font-size: larger;
  height: 94vh;
}

.bt-login {
    background-color: #d4af37;
    border: none;
    border-radius: 50px;
    padding: 8px 35px;
    color: #021d4c;
    font-size: 15px;
    font-weight: 700;
  }


</style>
